import { inject } from '@angular/core';
import { HttpInterceptorFn } from '@angular/common/http';
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { Location } from '@angular/common';
import { UserSessionStore } from '../services/user-session.store';
import { isPublicAuthPath } from '../helpers/auth-routes';

export const SKIP_AUTH_REDIRECT = 'X-Skip-Auth-Redirect';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const sessionStore = inject(UserSessionStore);
  const router = inject(Router);
  const location = inject(Location);
  const skipRedirect = req.headers.has(SKIP_AUTH_REDIRECT);
  const cleanedReq = skipRedirect ? req.clone({ headers: req.headers.delete(SKIP_AUTH_REDIRECT) }) : req;

  return next(cleanedReq).pipe(
    catchError(err => {
      if (err.status === 401 && !skipRedirect) {
        const redirect = err?.error?.redirect;

        if (redirect) {
          router.navigate([redirect]);
        } else {
          sessionStore.clearSession();
          const currentPath = location.path(true);
          if (!isPublicAuthPath(currentPath)) {
            router.navigate(['/login'], {
              queryParams: currentPath ? { fromUrl: currentPath } : undefined,
            });
          }
        }
      }

      return throwError(() => err);
    })
  );
};
